
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.53 9.956a1 1 0 010-1.698l9.358-5.83a1 1 0 011.529.848v11.662a1 1 0 01-1.529.848l-9.359-5.83z","fill":"#424242"}}),_c('path',{attrs:{"fill":"#424242","d":"M0 .295h2.333v16.366H0z"}})])
          )
        }
      }
    